const LocalStorageTool = {
    getLocalStorage: (key) => {
        return localStorage.getItem(key);
    },        
    getObjectFromLocalStorage: (key, defaultValue) => {
        let json = LocalStorageTool.getLocalStorage(key);
        if(json){
            return JSON.parse(json);
        }
        return defaultValue;
    }     
}

export default LocalStorageTool